import type { IEllipsisDropdownItemProps } from "@similarweb/ui-components";
import { getCountryIdOrFallback } from "app/pages/sales-intelligence/sub-modules/signals/utils/countries";
import type { ICountryObject } from "app/services/CountryService";
import FilterDropdownItemWithCheckbox from "../FilterDropdownItemWithCheckbox/FilterDropdownItemWithCheckbox";

export type FilterDropdownCountryItemProps = ICountryObject & Partial<IEllipsisDropdownItemProps>;

const FilterDropdownCountryItem = (props: FilterDropdownCountryItemProps) => {
    const { id, text, ...itemProps } = props;

    const countryId = getCountryIdOrFallback(id);

    return (
        <FilterDropdownItemWithCheckbox
            id={id}
            key={id}
            countryCode={countryId}
            text={text}
            {...itemProps}
        >
            {text}
        </FilterDropdownItemWithCheckbox>
    );
};

export default FilterDropdownCountryItem;
